module.exports = __webpack_public_path__ + "img/1.ce7c4628.jpg";